// removed by extract-text-webpack-plugin
module.exports = {"requestListItemMoreDetails":"columnsContainer__requestListItemMoreDetails___39suO","moreDetailsWrapper":"columnsContainer__moreDetailsWrapper___2qXir","columnDefault":"columnsContainer__columnDefault___1BXC1","textBlockEllipsis":"columnsContainer__textBlockEllipsis___2OcmZ"};


//////////////////
// WEBPACK FOOTER
// ./components/Scoreboard/columnsContainer.scss
// module id = ./components/Scoreboard/columnsContainer.scss
// module chunks = 5